import { useEffect, useRef } from "react";

const TravelWidget = () => {
  const widgetRef = useRef(null);

  useEffect(() => {
    if (!widgetRef.current) return;

    const scriptId = "travel-widget-script";

    // Avoid adding duplicate scripts
    if (document.getElementById(scriptId)) return;

    const script = document.createElement("script");
    script.id = scriptId;
    script.src = "//www.travelpayouts.com/widgets/2510377c763e8b89a57d326f2514bd0e.js?v=2012";
    script.charset = "utf-8";
    script.async = true;

    widgetRef.current.appendChild(script);

    return () => {
      // Remove the script safely
      document.getElementById(scriptId)?.remove();
    };
  }, []);

  return <div ref={widgetRef} id="travel-widget-container"></div>;
};

export default TravelWidget;
